module.exports = __webpack_public_path__ + "static/media/RG2_110.f016b84e.png";